import { DeviceAttribute } from './device-attribute.model';
import { DeviceOperationStateItem } from './device-operation-state-item.model';
import { DeviceParameter } from './device-parameter-model';
import { DeviceTypeData } from './device-type-data.model';
import { DeviceEvent } from "./device-event";

export interface Device {
  deviceId: number;
  deviceTypeId: number;
  externalDeviceId: string;
  valid: number;
  externalDeviceTypeCode: string;
  deviceTypeName: string;
  firmwareId: number;
  firmwareType: string;
  firmwareVersion: string;
  status: string;
  createdTimestamp: string;
  lastUpdatedTimestamp: string;
  lastChangeByMessageId: number;
  logisticStatus?: string;
  logisticStatusDesc?: string;
  writeRight: number;
  attributes: DeviceAttribute[];
  events: DeviceEvent[];
  operationStateItems: DeviceOperationStateItem[];
  sfDeviceAttribute?: SfDeviceAttribute;
}

export interface UpdateDeviceLogistic {
  deviceId: number;
  externalDeviceId: string;
  logisticStatus?: string;
  logisticStatusDesc?: string;
}

export interface UpdateDeviceLogisticResponse {
  deviceId: number;
  externalDeviceId: string;
  logisticStatus?: string;
  logisticStatusDesc?: string;
  lastUpdatedTimestamp: string;
}

export interface DeviceDataWrapper {
  device?: Device;
  deviceTypeData?: DeviceTypeData;
  deviceParameters?: DeviceParameter[];
  hasSensitiveData?: boolean;
}

export interface SfDeviceAttribute {
  factorySn: string;
  businessLine: string;
  sfDeviceName: string;
  sfProductName: string;
  sfCustomerName: string;
  sfDeviceType: string;
  deviceWidth: number;
  deviceLength: number;
  deviceHeight: number;
  sfHall: string;
  sfLocation: string;
  sfGateSignal: string;
  sfGateControllerSide: string;
  bfId: string;
  createdTimestamp: string;
  lastUpdatedTimestamp: string;
}

export interface DeviceDatasheetResponse {
  encodedPdf: string;
}


export const LogisticStatusValues = [
  'Awaiting programming',
  'Deployed',
  'HIBÁS REKORD',
  'Mechanic',
  'Repair needed',
  'Telcotrend',
  'Tester',
  'Awaiting assembly',
  'Károly',
  'Richárd',
].sort((a, b) => a.localeCompare(b));
